
import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './NodePagination.css';

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [pageInput, setPageInput] = useState(currentPage.toString());

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageInputChange = (event) => {
    setPageInput(event.target.value.replace(/\D/g, ''));
  };

  const handlePageInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const pageNumber = parseInt(pageInput, 10);
      if (pageNumber >= 1 && pageNumber <= totalPages) {
        onPageChange(pageNumber);
      } else {
        toast.warning(`Please enter a valid page number between 1 and ${totalPages}.`);
      }
    }
  };

  const handleRecordsChange = (event) => {
    const recordsNumber = parseInt(event.target.value, 10);
    onItemsPerPageChange(recordsNumber);
  };

  return (
    <div className="node-pagination-container">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <div className="records-per-page-container-node">
        <select
          id="records-dropdown"
          className="records-per-page-dropdown"
          value={itemsPerPage}
          onChange={handleRecordsChange}
        >
          {[5, 10, 15].map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <label htmlFor="records-dropdown" className="dropdown-label">
          Records per page
        </label>
      </div>

      <div className="pagination-controls">
        <button
          className="pagination-button"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          ◄
        </button>

        <input
          type="text"
          className="pagination-input"
          value={pageInput}
          onChange={handlePageInputChange}
          onKeyDown={handlePageInputSubmit}
        />
        <span className="pagination-info">
          of {totalPages}
        </span>

        <button
          className="pagination-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          ►
        </button>
      </div>
    </div>
  );
};

export default Pagination;